import { render, staticRenderFns } from "./FullscreenGalleryItemImg.vue?vue&type=template&id=1aabd644"
import script from "./FullscreenGalleryItemImg.vue?vue&type=script&lang=ts"
export * from "./FullscreenGalleryItemImg.vue?vue&type=script&lang=ts"
import style0 from "./FullscreenGalleryItemImg.vue?vue&type=style&index=0&id=1aabd644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports